import { useState, useCallback } from 'react';
import { APIService } from '../services/api';

export function useUserDomains() {
  const [userDomains, setUserDomains] = useState([]);
  const [userDomainGroups, setUserDomainGroups] = useState([]);
  const [userDomainsLimits, setUserDomainsLimits] = useState(null);
  const [removingDomain, setRemovingDomain] = useState(null);
  const [trackedOrigins, setTrackedOrigins] = useState([]);
  
  const [showCreateGroupForm, setShowCreateGroupForm] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [newGroupName, setNewGroupName] = useState('');
  const [newGroupDescription, setNewGroupDescription] = useState('');
  const [newGroupColor, setNewGroupColor] = useState('#3b82f6');
  const [bulkImportGroupId, setBulkImportGroupId] = useState(null);
  const [bulkImportText, setBulkImportText] = useState('');
  const [bulkImportLoading, setBulkImportLoading] = useState(false);

  const loadUserDomains = useCallback(async () => {
    try {
      const result = await APIService.getUserDomains();
      if (result && result.success !== false) {
        setUserDomains(result.domains || []);
        setUserDomainGroups(result.groups || []);
        setUserDomainsLimits(result.limits || null);
      }
    } catch (err) {
      console.error('Failed to load user domains:', err);
    }
  }, []);

  const resetGroupForm = useCallback(() => {
    setShowCreateGroupForm(false);
    setEditingGroup(null);
    setNewGroupName('');
    setNewGroupDescription('');
    setNewGroupColor('#3b82f6');
  }, []);

  const resetBulkImport = useCallback(() => {
    setBulkImportGroupId(null);
    setBulkImportText('');
    setBulkImportLoading(false);
  }, []);

  return {
    userDomains,
    setUserDomains,
    userDomainGroups,
    setUserDomainGroups,
    userDomainsLimits,
    setUserDomainsLimits,
    removingDomain,
    setRemovingDomain,
    trackedOrigins,
    setTrackedOrigins,
    showCreateGroupForm,
    setShowCreateGroupForm,
    editingGroup,
    setEditingGroup,
    newGroupName,
    setNewGroupName,
    newGroupDescription,
    setNewGroupDescription,
    newGroupColor,
    setNewGroupColor,
    bulkImportGroupId,
    setBulkImportGroupId,
    bulkImportText,
    setBulkImportText,
    bulkImportLoading,
    setBulkImportLoading,
    loadUserDomains,
    resetGroupForm,
    resetBulkImport
  };
}

export default useUserDomains;
